import { render, staticRenderFns } from "./AdvHedgeAppBaseForm.vue?vue&type=template&id=1f97a663&scoped=true&"
import script from "./AdvHedgeAppBaseForm.vue?vue&type=script&lang=js&"
export * from "./AdvHedgeAppBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97a663",
  null
  
)

export default component.exports